import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { routerBasename } from './lib/router';
import { purgeLegacySupabaseLocalStorage } from './features/auth/supabaseStorage';
import { purgeLegacyCalendarResourceIds } from './features/calendar/calendarPersistence';
import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/bricolage-grotesque/500.css';
import '@fontsource/bricolage-grotesque/600.css';
import '@fontsource/bricolage-grotesque/700.css';
import './app/styles.css';
import './app/theme-c.css';

// Privacy migrations run before any route or auth component can consume the
// browser stores. Both functions are deliberately idempotent and best effort.
purgeLegacySupabaseLocalStorage();
purgeLegacyCalendarResourceIds();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Internal ops tool with low write frequency: keep fetched screens fresh
      // for a few minutes so moving between tabs serves from cache instead of
      // re-hitting the (Fibery-backed) backend on every navigation. Mutations
      // still invalidate their affected keys explicitly.
      staleTime: 120_000,
      gcTime: 900_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={routerBasename()}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
